import React, {useState} from 'react';
import carCharge from '../../images/carCharge.jpg'
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Card, CardActions, CardContent} from "@mui/material";
import EvStationIcon from '@mui/icons-material/EvStation';
import CableIcon from '@mui/icons-material/Cable';
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import Grid2 from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import ContactUs from "../ContactUs";
import AnimatedBackgroundBox from "../AnimationBackgroundBox";
import Partenaires from "../Partenaires";

const MobiliteElec = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        compagny: '',
        phoneNumber:'',
        message: '',
    });

    // Permet de mettre a jour les data saisies par l'user
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    return (
        <React.Fragment>
            <AnimatedBackgroundBox backgroundImage={carCharge} position={'bottom'} size={'200%'}>
                <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#ebefef', fontFamily: 'unset',
                    textShadow: `
                            0px 0px 8px rgba(0, 0, 0, 0.5),   
                            0px 0px 16px rgba(0, 0, 0, 0.5),  
                            0px 0px 24px rgba(0, 0, 0, 0.5)   
                        `,
                    fontSize: {
                        xs: '2.5rem', // Taille plus petite sur les téléphones
                        sm: '2.5rem', // Taille moyenne sur les tablettes
                        md: '5rem', // Taille normale sur les grands écrans
                    },
                }}>
                    Mobilité électrique
                </Typography>
                {/*            <Typography variant="body2" sx={{ color: 'text.secondary' }}>*/}
                {/*                Nous installons des bornes de recharge pour véhicules électriques à domicile et en entreprise.*/}
                {/*                Profitez de solutions fiables et sur-mesure, adaptées à vos besoins de mobilité.*/}
                {/*            </Typography>*/}
            </AnimatedBackgroundBox>

            <Box sx={{ padding: { xs: '20px ', md: '70px 0' }, backgroundColor: '#f0f4fa ' }}>
                <Box sx={{ maxWidth: 'lg', margin: 'auto', display: 'flex', justifyContent: 'center', flexWrap: 'wrap'}}> {/* Centrage horizontal du conteneur */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontFamily: 'unset',
                            color: '#2c2d2e',
                            paddingBottom: '50px',
                            textAlign: 'center', // Centrage du texte
                            //fontStyle: 'italic'
                            fontSize: { xs: '1.5rem', md: '2rem' }, // Taille réduite sur mobile
                        }}
                    >
                        Chez CP, nous proposons des solutions de mobilité électrique pour les professionnels et les particuliers,
                        alliant innovation, performance et respect de l’environnement.
                        {/*Que ce soit pour l'installation, la rénovation ou la maintenance de vos systèmes électriques, nous garantissons sécurité, performance et conformité, tout en optimisant votre consommation énergétique.*/}
                    </Typography>
                    <Grid2 container spacing={4} justifyContent="center"> {/* Centrage des cartes */}
                        {/** Tableau de données pour les cartes */}
                        {[
                            {
                                icon: <EvStationIcon sx={{ fontSize: 75, color: '#05acf3' }} />,
                                title: "INSTALLATION",
                                description: "Nous installons des bornes de recharge pour véhicules électriques à domicile ou en entreprise, adaptées à vos besoins en énergie.",
                                button: null,
                            },
                            {
                                icon: <CableIcon sx={{ fontSize: 75, color: '#05acf3' }} />,
                                title: "ENTRETIEN & MAINTENANCE",
                                description: "Assurez le bon fonctionnement de vos bornes de recharge avec nos services de maintenance préventive et corrective.",
                                button: null,
                            },
                            {
                                icon: <EuroSymbolIcon sx={{ fontSize: 75, color: '#05acf3' }} />,
                                title: "SUBVENTIONS & AIDES",
                                description: "Profitez des subventions et aides gouvernementales pour l’installation de bornes de recharge et la transition vers la mobilité électrique.",
                                button: (
                                    <Button
                                        href={"https://www.ecologie.gouv.fr/sites/default/files/documents/VDEF%2022056_Borne-%C3%A9lectrique-r%C3%A9sidentiel.pdf"}
                                        size="medium"
                                        target="_blank" // ouvre le lien dans un nouvel onglet
                                        rel="noopener noreferrer" // pour ajouter une couche de sécu
                                    >
                                        En savoir plus
                                    </Button>
                                ),
                            },
                        ].map((card, index) => (
                            <Grid2 xs={12} sm={6} md={6} key={index}>
                                <Card
                                    sx={{
                                        minWidth: 300,
                                        minHeight: 300,
                                        maxHeight: 350,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center', // Centrage du contenu
                                        alignItems: 'center',
                                        borderRadius: 8,
                                        //boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3), 0px 10px 20px rgba(0, 0, 0, 0.5)' // Ombre plus accentuée
                                        boxShadow: '0px 5px 5px rgb(170, 187, 250, 0.5), 0px 5px 10px rgb(170, 187, 250, 0.4) '

                                    }}
                                >
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                                            {card.icon}
                                        </Box>
                                        <Typography variant='h4' sx={{ textAlign: 'center', mb: 1.5, fontFamily: 'unset' }}>
                                            {card.title}
                                        </Typography>
                                        <Typography variant="subtitle1" sx={{ textAlign: 'center', fontFamily: 'unset' }}>
                                            {card.description}
                                        </Typography>
                                    </CardContent>
                                    {card.button && (
                                        <CardActions>
                                            {card.button}
                                        </CardActions>
                                    )}
                                </Card>
                            </Grid2>
                        ))}
                    </Grid2>

                </Box>
            </Box>

            <Box>
                <Partenaires></Partenaires>
            </Box>

            <Box>
                <ContactUs></ContactUs>
            </Box>
        </React.Fragment>

    );
};

export default MobiliteElec;